export default __webpack_public_path__ + "static/article-5-dog-breeds-with-low-bellies-ecfcfcc493c73c3e4332b64ee3a073ba.jpg";